<template>
  <div class="star-rating">
    <div v-for="i in 5" :key="i" class="star">
      <icon v-if="i <= stars" icon="star-filled" class="icon" />
      <icon v-else-if="half && i == stars + 1" icon="star-half" class="icon" />
      <icon v-else icon="star-empty" class="icon" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rating: { type: Number, default: 0 },
  },
  data() {
    return {
      stars: 0,
      half: false,
    };
  },
  watch: {
    rating(val) {
      this.calculate();
    },
  },
  methods: {
    calculate() {
      let stars = Math.floor(this.rating);
      let fraction = Math.round((this.rating - stars) * 10);
      if (fraction > 7) {
        stars++;
      } else if (fraction >= 3 && fraction <= 7) {
        this.half = true;
      }
      this.stars = stars;
    },
  },
  created() {
    this.calculate();
  },
};
</script>
